import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["className", "prefixCls", "image", "description", "children", "imageStyle"];
import classNames from "classnames";
import * as React from "react";
import { ConfigContext } from "../ConfigProvider";
import LocaleReceiver from "../LocaleProvider/LocaleReceiver";
import DefaultEmptyImg from "./Empty";
import SimpleEmptyImg from "./Simple";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultEmptyImg = /*#__PURE__*/_jsx(DefaultEmptyImg, {});
var simpleEmptyImg = /*#__PURE__*/_jsx(SimpleEmptyImg, {});
var Empty = function Empty(_ref) {
  var className = _ref.className,
    customizePrefixCls = _ref.prefixCls,
    _ref$image = _ref.image,
    image = _ref$image === void 0 ? defaultEmptyImg : _ref$image,
    description = _ref.description,
    _children = _ref.children,
    imageStyle = _ref.imageStyle,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction;
  return (
    /*#__PURE__*/
    // @ts-ignore
    _jsx(LocaleReceiver, {
      componentName: "Empty",
      children: function children(locale) {
        var _classNames;
        var prefixCls = getPrefixCls("empty", customizePrefixCls);
        var des = typeof description !== "undefined" ? description : locale === null || locale === void 0 ? void 0 : locale.description;
        var alt = typeof des === "string" ? des : "empty";
        var imageNode = null;
        if (typeof image === "string") {
          imageNode = /*#__PURE__*/_jsx("img", {
            alt: alt,
            src: image
          });
        } else {
          imageNode = image;
        }
        return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
          className: classNames(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), _defineProperty(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className)
        }, restProps), {}, {
          children: [/*#__PURE__*/_jsx("div", {
            className: "".concat(prefixCls, "-image"),
            style: imageStyle,
            children: imageNode
          }), des && /*#__PURE__*/_jsx("div", {
            className: "".concat(prefixCls, "-description"),
            children: des
          }), _children && /*#__PURE__*/_jsx("div", {
            className: "".concat(prefixCls, "-footer"),
            children: _children
          })]
        }));
      }
    })
  );
};
Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
export default Empty;